module.exports = __webpack_public_path__ + "img/watch-black.71b9906b.png";